'use strict';exports.__esModule = true;exports.fetchMenuItemData = exports.menuBlocksRules = undefined;var _constants = require('../../constants');







var menuItemsData = {
  homePage: {
    title: 'homePage',
    iconName: 'home-page',
    link: '/' },

  publishProperty: {
    title: 'publishProperty',
    iconName: 'publish',
    link: '/publish' },

  foreignPublishProperty: {
    title: 'foreignPublishProperty',
    iconName: 'publish',
    link: '/foreign_publish' },

  signIn: {
    title: 'signIn',
    iconName: 'login',
    link: '' },

  newAccount: {
    title: 'newAccount',
    iconName: 'new-account',
    link: '' },

  editProfile: {
    title: 'myAccount',
    iconName: 'user',
    link: '/profile/edit' },

  mySearches: {
    title: 'mySearches',
    iconName: 'my-searches',
    link: '/profile/searches' },

  myCompany: {
    title: 'myCompany',
    iconName: 'contacts-office',
    link: '/profile/my_company' },

  leads: {
    title: 'leads',
    iconName: 'leads',
    link: '/profile/leads' },

  // TODO ONMAP-757
  // myStaff: {
  //   title: 'myStaff',
  //   iconName: 'leads',
  //   link: '/profile/my_staff'
  // },
  myProjects: {
    title: 'my_projects',
    iconName: 'projects',
    link: '/profile/my_projects' },

  mySubscriptions: {
    title: 'mySubscriptions',
    iconName: 'mail',
    link: '/profile/my_subscriptions' },

  manageProperties: {
    title: 'manageProperties',
    iconName: 'manage',
    link: '/manage_properties' },

  logOut: {
    title: 'logOut',
    iconName: 'logout',
    link: '' },

  aboutUs: {
    title: 'aboutUs',
    iconName: 'about',
    link: '/about' },

  articles: {
    title: 'articles',
    iconName: 'articles',
    link: '/articles' },

  contactUs: {
    title: 'contactUs',
    iconName: 'mail',
    link: '/contact' },

  search: {
    title: 'search',
    iconName: 'search',
    link: '' },

  forSale: {
    title: 'buy',
    iconName: 'for-sale',
    link: '' },

  forRent: {
    title: 'rent',
    iconName: 'for-rent',
    link: '' },

  commercial: {
    title: 'commercial',
    iconName: 'commercial',
    link: '/' + _constants.sections.commercial.location + '/' + _constants.optionTypes.rent },

  projects: {
    title: 'projects',
    iconName: 'new-project',
    link: '/projects' },

  foreign: {
    title: '' + _constants.ROUTES_PATHS.FOREIGN,
    iconName: 'overseas-real-estate',
    link: '/' + _constants.ROUTES_PATHS.FOREIGN,
    isNew: true },

  favorites: {
    title: 'favorites',
    iconName: 'favorite',
    link: '' },

  ios: {
    title: 'iosApp',
    iconName: 'ios',
    link: '',
    url: _constants.appStoreLink },

  android: {
    title: 'androidApp',
    iconName: 'android-outline',
    link: '',
    url: _constants.playmarketLink },

  professionals: {
    title: 'professionals',
    iconName: 'professionals',
    link: '/professionals' },

  // TODO ONMAP-757
  // realtorPage: {
  //   title: 'realtorPage',
  //   iconName: 'leads',
  //   link: '/profile/realtor_page'
  // },
  vr_promotion: {
    title: 'vrPromotion',
    iconName: 'video-view',
    link: '/vr_promotion' },

  realtorContactUs: {
    title: 'realtorContactUs',
    iconName: 'articles',
    link: '/contact_us_realtor' } };



var menuBlocksRules = exports.menuBlocksRules = {
  header: ['homePage'],
  publishProperty: ['publishProperty'],
  foreignPublishProperty: ['foreignPublishProperty'],
  foreignIsraelPublishProperty: ['publishProperty', 'foreignPublishProperty'],
  search: ['forSale', 'forRent', 'commercial', 'projects', 'foreign'],
  userAuthorized: ['editProfile', 'mySearches', 'favorites', 'mySubscriptions'],
  userAuthorizedWithCompany: ['editProfile', 'myCompany', 'mySearches', 'favorites', 'leads', 'myProjects', 'mySubscriptions'],
  // TODO ONMAP-757
  // userAuthorizedWithUserStaff: ['editProfile', 'myCompany', 'mySearches', 'favorites', 'leads', 'myProjects', 'realtorPage', 'mySubscriptions'],
  userAuthorizedWithUserStaff: ['editProfile', 'myCompany', 'mySearches', 'favorites', 'leads', 'myProjects', 'mySubscriptions'],
  userAuthorizedWithProperties: ['manageProperties', 'editProfile', 'mySearches', 'favorites', 'leads', 'myProjects', 'mySubscriptions'],
  userAuthorizedWithPropertiesWithCompany: ['manageProperties', 'editProfile', 'myCompany', 'mySearches', 'favorites', 'leads', 'myProjects', 'mySubscriptions'],
  // TODO ONMAP-757
  // userAuthorizedWithPropertiesWithUserStaff: ['manageProperties', 'editProfile', 'myCompany', 'mySearches', 'favorites', 'leads', 'myProjects', 'realtorPage', 'mySubscriptions'],
  userAuthorizedWithPropertiesWithUserStaff: ['manageProperties', 'editProfile', 'myCompany', 'mySearches', 'favorites', 'leads', 'myProjects', 'mySubscriptions'],
  userAuthorizedWithPropertiesWithMyStaff: ['manageProperties', 'editProfile', 'mySearches', 'favorites', 'leads', 'myProjects', 'mySubscriptions'],
  // TODO ONMAP-757
  // userAuthorizedWithPropertiesWithMyStaff: ['manageProperties', 'editProfile', 'mySearches', 'favorites', 'leads', 'myProjects', 'myStaff', 'mySubscriptions'],
  userAuthorizedWithPropertiesWithCompanyWithMyStaff: ['manageProperties', 'editProfile', 'myCompany', 'mySearches', 'favorites', 'leads', 'myProjects', 'mySubscriptions'],
  // TODO ONMAP-757
  // userAuthorizedWithPropertiesWithCompanyWithMyStaff: ['manageProperties', 'editProfile', 'myCompany', 'mySearches', 'favorites', 'leads', 'myStaff', 'myProjects', 'mySubscriptions'],
  // TODO ONMAP-757
  // userAuthorizedWithPropertiesWithCompanyWithUserStaff: ['manageProperties', 'editProfile', 'myCompany', 'mySearches', 'favorites', 'leads', 'realtorPage', 'myProjects', 'mySubscriptions'],
  userAuthorizedWithPropertiesWithCompanyWithUserStaff: ['manageProperties', 'editProfile', 'myCompany', 'mySearches', 'favorites', 'leads', 'myProjects', 'mySubscriptions'],
  // TODO ONMAP-757
  // userAuthorizedWithPropertiesWithCompanyWithMyStaffWithUserStaff: ['manageProperties', 'editProfile', 'myCompany', 'mySearches', 'favorites', 'leads', 'realtorPage', 'myProjects', 'mySubscriptions'],
  userAuthorizedWithPropertiesWithCompanyWithMyStaffWithUserStaff: ['manageProperties', 'editProfile', 'myCompany', 'mySearches', 'favorites', 'leads', 'myProjects', 'mySubscriptions'],
  // TODO ONMAP-757
  // userAuthorizedWithPropertiesWithCompanyWithMyStaffWithUserStaff: ['manageProperties', 'editProfile', 'myCompany', 'mySearches', 'favorites', 'leads', 'myStaff', 'realtorPage', 'myProjects', 'mySubscriptions'],
  userNotAuthorized: ['signIn', 'newAccount', 'favorites'],
  iOsApplication: ['ios'],
  androidApplication: ['android'],
  footer: ['realtorContactUs', 'professionals', 'vr_promotion', 'articles', 'contactUs', 'aboutUs'] };


var fetchMenuItemData = exports.fetchMenuItemData = function fetchMenuItemData(name, clickHandler) {
  menuItemsData[name].clickHandler = clickHandler;
  return menuItemsData[name];
};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/HeaderMobileRenderRules.js
// module id = 2649
// module chunks = 0